import { DUCK, TYPE_MASK, goosePhase, squareName } from '@chessbut/engine';
import type { VariantUi } from './ui.ts';

const GOOSE = '/art/goose.svg';

export const gooseUi: VariantUi = {
  heroImage: GOOSE,
  peek: [{}, { image: '/art/bK.svg' }, {}, {}, { image: GOOSE, threat: true }, {}, {}, { image: '/art/wQ.svg' }, {}],

  pieceImage(_pos, _sq, piece) {
    return (piece & TYPE_MASK) === DUCK ? GOOSE : null;
  },

  pieceLabel(_pos, _sq, piece) {
    return (piece & TYPE_MASK) === DUCK ? 'goose' : null;
  },

  twist(pos, you) {
    if (goosePhase(pos)) {
      if (you === null || pos.turn === you) return { text: 'Now move the goose: tap any empty square', alert: false, pips: { on: 1, total: 2, title: 'Piece move, then goose move' } };
      return { text: 'They’re moving the goose…', pips: { on: 1, total: 2, title: 'Piece move, then goose move' } };
    }
    if (you === null || pos.turn === you) return { text: 'Move a piece, then the goose. No check here!', pips: { on: 0, total: 2, title: 'Piece move, then goose move' } };
    return { text: 'Their move. Watch out: kings can be captured.' };
  },

  eventSound(e) {
    return (e.t === 'move' || e.t === 'add') && (e.piece & TYPE_MASK) === DUCK ? 'honk' : null;
  },

  san(rec) {
    const e = rec.events.find((x) => (x.t === 'move' || x.t === 'add') && (x.piece & TYPE_MASK) === DUCK);
    if (!e) return null;
    return `🪿${squareName(e.t === 'move' ? e.to : e.sq)}`;
  },
};
